import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSaveTermQuote = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "saveQuote",
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		id: "Group_16929",
		"data-name": "Group 16929",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12564",
				"data-name": "Path 12564",
				d: "M6,7.583,3.323,10.049a1,1,0,0,0,.116,1.563l7.442,5.043a2,2,0,0,0,2.246,0l7.435-5.039a1,1,0,0,0,.112-1.567L18,7.619",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12565",
				"data-name": "Path 12565",
				d: "M3,10.75v9.225A1.013,1.013,0,0,0,4,21H20a1.013,1.013,0,0,0,1-1.025V10.75",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12566",
				"data-name": "Path 12566",
				d: "M3.3,20.7l5.47-5.47",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12567",
				"data-name": "Path 12567",
				d: "M15.23,15.23,20.7,20.7",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12568",
				"data-name": "Path 12568",
				d: "M18,13.278V4a1,1,0,0,0-1-1H7A1,1,0,0,0,6,4v9.278",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12576",
				"data-name": "Path 12576",
				d: "M18,21s3-1.44,3-3.6V14.88l-2.188-.787a2.39,2.39,0,0,0-1.626,0L15,14.88V17.4C15,19.56,18,21,18,21Z",
				transform: "translate(-6 -8)",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			})
		]
	}), /* @__PURE__ */ _jsx("path", {
		id: "Path_12570",
		"data-name": "Path 12570",
		d: "M0,0H24V24H0Z",
		fill: "none"
	})]
});
export default SvgSaveTermQuote;
